<template>

  <div class="workspace-orcamentos-page">

    <div class="modern-header">
      <div class="header-container">
        <div class="breadcrumb-section">
          <nav class="breadcrumb">
            <button type="button" class="breadcrumb-item" @click="$router.push('/dashboard')">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
              </svg>
              {{ t('common.breadcrumb.dashboard') }}
            </button>
            <span class="breadcrumb-separator">/</span>
            <button type="button" class="breadcrumb-item" @click="$router.push(`/workspace/${workspaceId}`)">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
              </svg>
              {{ workspaceName }}
            </button>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-current">{{ t('orcamentos.list.breadcrumb') }}</span>
          </nav>
        </div>

        <div class="title-section">
          <div class="title-content">
            <div class="title-icon title-icon--crm">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
              </svg>
            </div>
            <div class="title-text">
              <h1 class="main-title">{{ t('orcamentos.list.title') }}</h1>
              <p class="subtitle">{{ t('orcamentos.list.subtitle') }}</p>
            </div>
          </div>
          <div class="workspace-badge type-crm">
            <div class="badge-icon">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
              </svg>
            </div>
            <span class="badge-text">CRM</span>
          </div>
        </div>

        <div class="actions-section">
          <div class="actions-left" />
          <div class="actions-right">
            <button type="button" class="action-button secondary" @click="$router.push(`/workspace/${workspaceId}/configuracoes`)">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
              </svg>
              {{ t('orcamentos.list.config') }}
            </button>
            <button type="button" class="action-button secondary" @click="novoOrcamento">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
              </svg>
              {{ t('orcamentos.list.new') }}
            </button>
            <button type="button" class="action-button primary" @click="$router.push(`/workspace/${workspaceId}/dashboard`)">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
              </svg>
              {{ t('orcamentos.list.back') }}
            </button>
          </div>
        </div>
      </div>
    </div>



    <div class="orc-page-content page-content">

      <div v-if="loading" class="orc-list-loading">

        <div class="orc-list-loading__spinner" />

        <p>{{ t('orcamentos.loading') }}</p>

      </div>



      <template v-else>

        <div class="orc-kpi-grid">

          <div class="orc-kpi-card">

            <div class="orc-kpi-card__icon orc-kpi-card__icon--total">

              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>

            </div>

            <div>

              <span class="orc-kpi-card__label">{{ t('orcamentos.list.kpiTotal') }}</span>

              <strong class="orc-kpi-card__value">{{ stats.total }}</strong>

            </div>

          </div>

          <div class="orc-kpi-card">

            <div class="orc-kpi-card__icon orc-kpi-card__icon--published">

              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>

            </div>

            <div>

              <span class="orc-kpi-card__label">{{ t('orcamentos.list.kpiPublished') }}</span>

              <strong class="orc-kpi-card__value">{{ stats.publicados }}</strong>

            </div>

          </div>

          <div class="orc-kpi-card">

            <div class="orc-kpi-card__icon orc-kpi-card__icon--draft">

              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/></svg>

            </div>

            <div>

              <span class="orc-kpi-card__label">{{ t('orcamentos.list.kpiDrafts') }}</span>

              <strong class="orc-kpi-card__value">{{ stats.rascunhos }}</strong>

            </div>

          </div>

          <div class="orc-kpi-card orc-kpi-card--highlight">

            <div class="orc-kpi-card__icon orc-kpi-card__icon--value">

              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>

            </div>

            <div>

              <span class="orc-kpi-card__label">{{ t('orcamentos.list.kpiValue') }}</span>

              <strong class="orc-kpi-card__value orc-kpi-card__value--money">{{ formatMoney(stats.valorTotal) }}</strong>

            </div>

          </div>

        </div>



        <div v-if="items.length" class="orc-list-toolbar">

          <div class="orc-list-search">

            <svg class="orc-list-search__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/></svg>

            <input v-model="search" type="search" :placeholder="t('orcamentos.list.searchPlaceholder')" />

          </div>

          <div class="orc-list-filters">

            <button

              v-for="f in statusFilters"

              :key="f.value"

              type="button"

              class="orc-list-filter"

              :class="{ 'orc-list-filter--active': statusFilter === f.value }"

              @click="statusFilter = f.value"

            >

              {{ f.label }}

              <span class="orc-list-filter__count">{{ f.count }}</span>

            </button>

            <button

              v-if="archivedCount > 0"

              type="button"

              class="orc-list-filter orc-list-filter--archived"

              :class="{ 'orc-list-filter--active': showArchived }"

              :title="t('orcamentos.list.showArchivedHint')"

              @click="showArchived = !showArchived"

            >

              {{ t('orcamentos.list.showArchived') }}

              <span class="orc-list-filter__count">{{ archivedCount }}</span>

            </button>

          </div>

        </div>



        <div v-if="!items.length" class="orc-list-empty">

          <div class="orc-list-empty__visual">

            <div class="orc-list-empty__doc">

              <svg class="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>

            </div>

          </div>

          <h2>{{ t('orcamentos.list.emptyTitle') }}</h2>

          <p>{{ t('orcamentos.list.emptyHint') }}</p>

          <button type="button" class="orc-list-cta" @click="novoOrcamento">

            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/></svg>

            {{ t('orcamentos.list.emptyCta') }}

          </button>

        </div>



        <div v-else-if="items.length && !listItems.length && archivedCount > 0" class="orc-list-empty orc-list-empty--compact">

          <p>{{ t('orcamentos.list.allArchivedHint') }}</p>

          <button type="button" class="orc-list-cta orc-list-cta--compact" @click="showArchived = true">

            {{ t('orcamentos.list.showArchived') }}

          </button>

        </div>



        <div v-else-if="!filteredItems.length" class="orc-list-empty orc-list-empty--compact">

          <p>{{ t('orcamentos.list.noResults') }}</p>

        </div>



        <div v-else class="orc-list-wrap">

        <div class="orc-list">

          <article

            v-for="item in paginatedItems"

            :key="item.id"

            class="orc-list-card"

            :class="{

              'orc-list-card--published': item.status === 'PUBLICADO' && !isOrcamentoHidden(item),

              'orc-list-card--expired': isOrcamentoExpired(item),

              'orc-list-card--archived': isOrcamentoManuallyArchived(item)

            }"

          >

            <div class="orc-list-card__doc-icon">

              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>

            </div>



            <div class="orc-list-card__main">

              <div class="orc-list-card__top">

                <span class="orc-list-row__num">{{ item.numero }}</span>

                <span

                  v-if="isOrcamentoManuallyArchived(item)"

                  class="orc-status orc-status--arquivado"

                >

                  {{ t('orcamentos.status.arquivado') }}

                </span>

                <span

                  v-else-if="isOrcamentoExpired(item)"

                  class="orc-status orc-status--expirado"

                >

                  {{ t('orcamentos.status.expirado') }}

                </span>

                <span

                  v-else

                  class="orc-status"

                  :class="item.status === 'PUBLICADO' ? 'orc-status--publicado' : 'orc-status--rascunho'"

                >

                  {{ item.status === 'PUBLICADO' ? t('orcamentos.status.publicado') : t('orcamentos.status.rascunho') }}

                </span>

              </div>

              <h3 class="orc-list-row__title">{{ item.titulo || t('orcamentos.list.untitled') }}</h3>

              <div class="orc-list-card__meta">

                <span v-if="item.leadNome" class="orc-list-card__chip">

                  <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/></svg>

                  {{ item.leadNome }}

                </span>

                <span v-if="validadeLabel(item)" class="orc-list-card__validity" :class="{ 'orc-list-card__validity--expired': isOrcamentoExpired(item) }">

                  {{ isOrcamentoExpired(item)

                    ? t('orcamentos.list.expiredOn', { date: validadeLabel(item) })

                    : t('orcamentos.list.validUntil', { date: validadeLabel(item) }) }}

                </span>

              </div>

            </div>



            <div class="orc-list-card__aside">

              <div class="orc-list-row__value">{{ formatMoney(item.valorTotal) }}</div>

              <div class="orc-row-actions">

                <button type="button" class="orc-btn orc-btn--ghost" @click="editar(item.id)">

                  <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/></svg>

                  {{ t('orcamentos.actions.edit') }}

                </button>

                <button v-if="item.publicUrl" type="button" class="orc-btn orc-btn--ghost" @click="copiar(item.publicUrl)">

                  <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/></svg>

                  {{ copiedId === item.id ? t('orcamentos.list.copied') : t('orcamentos.actions.copyLink') }}

                </button>

                <button
                  v-if="!isOrcamentoManuallyArchived(item)"
                  type="button"
                  class="orc-btn orc-btn--ghost orc-btn--archive"
                  :disabled="archivingId === item.id"
                  @click="arquivarOrcamento(item)"
                >

                  <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"/></svg>

                  {{ t('orcamentos.actions.archive') }}

                </button>

              </div>

            </div>

          </article>

        </div>

        <footer v-if="totalPages > 1" class="orc-list-pagination">
          <span class="orc-list-pagination__info">
            {{ t('orcamentos.list.pagination.showing', { start: paginationStart, end: paginationEnd, total: totalFiltered }) }}
          </span>
          <div class="orc-list-pagination__controls">
            <button type="button" class="orc-list-pagination__btn" :disabled="page <= 1" @click="goToPage(page - 1)">
              {{ t('orcamentos.list.pagination.prev') }}
            </button>
            <span class="orc-list-pagination__page">
              {{ t('orcamentos.list.pagination.pageOf', { current: page, total: totalPages }) }}
            </span>
            <button type="button" class="orc-list-pagination__btn" :disabled="page >= totalPages" @click="goToPage(page + 1)">
              {{ t('orcamentos.list.pagination.next') }}
            </button>
          </div>
        </footer>

        </div>

      </template>

    </div>

  </div>

</template>



<script setup>

import { ref, computed, onMounted, watch } from 'vue'

import { useRoute, useRouter } from 'vue-router'

import { useI18n } from 'vue-i18n'

import api from '@/services/api'

import { useGlobalWorkspaces } from '@/composables/useGlobalWorkspaces'

import Swal from 'sweetalert2'
import { formatOrcamentoMoney } from '@/utils/orcamentoUtils'
import { formatLocalDate, parseLocalDate } from '@/utils/format'
import '@/assets/styles/workspace-orcamentos.css'

const PAGE_SIZE = 25

const route = useRoute()

const router = useRouter()

const { t, locale } = useI18n()

const { currentWorkspace } = useGlobalWorkspaces()



const workspaceId = computed(() => Number(route.params.id) || null)

const workspaceName = computed(() => currentWorkspace.value?.nome || t('workspaceDashboard.defaultName'))

const loading = ref(false)

const items = ref([])

const search = ref('')

const statusFilter = ref('ALL')

const showArchived = ref(false)

const page = ref(1)

const copiedId = ref(null)

const archivingId = ref(null)

let copiedTimer = null



const formatMoney = formatOrcamentoMoney



function startOfToday () {

  const today = new Date()

  today.setHours(0, 0, 0, 0)

  return today

}



function isOrcamentoManuallyArchived (item) {
  return Boolean(item?.arquivado)
}

function isOrcamentoExpired (item) {

  if (!item || item.status !== 'PUBLICADO' || !item.validadeAte) return false

  const validade = parseLocalDate(item.validadeAte)

  if (!validade) return false

  validade.setHours(0, 0, 0, 0)

  return validade < startOfToday()

}

function isOrcamentoHidden (item) {
  return isOrcamentoManuallyArchived(item) || isOrcamentoExpired(item)
}



const archivedCount = computed(() => items.value.filter(isOrcamentoHidden).length)



const listItems = computed(() => {

  if (showArchived.value) return items.value

  return items.value.filter(item => !isOrcamentoHidden(item))

})



const stats = computed(() => {

  const list = listItems.value

  return {

    total: list.length,

    publicados: list.filter(i => i.status === 'PUBLICADO').length,

    rascunhos: list.filter(i => i.status !== 'PUBLICADO').length,

    valorTotal: list.reduce((s, i) => s + (Number(i.valorTotal) || 0), 0)

  }

})



const statusFilters = computed(() => [

  { value: 'ALL', label: t('orcamentos.list.filterAll'), count: listItems.value.length },

  { value: 'PUBLICADO', label: t('orcamentos.list.filterPublished'), count: stats.value.publicados },

  { value: 'RASCUNHO', label: t('orcamentos.list.filterDraft'), count: stats.value.rascunhos }

])



const filteredItems = computed(() => {

  const q = search.value.trim().toLowerCase()

  return listItems.value.filter(item => {

    if (statusFilter.value !== 'ALL' && item.status !== statusFilter.value) return false

    if (!q) return true

    const hay = [item.numero, item.titulo, item.leadNome].filter(Boolean).join(' ').toLowerCase()

    return hay.includes(q)

  })

})

const totalFiltered = computed(() => filteredItems.value.length)

const totalPages = computed(() => Math.max(1, Math.ceil(totalFiltered.value / PAGE_SIZE)))

const paginatedItems = computed(() => {
  const start = (page.value - 1) * PAGE_SIZE
  return filteredItems.value.slice(start, start + PAGE_SIZE)
})

const paginationStart = computed(() => {
  if (totalFiltered.value === 0) return 0
  return (page.value - 1) * PAGE_SIZE + 1
})

const paginationEnd = computed(() => {
  if (totalFiltered.value === 0) return 0
  return Math.min(page.value * PAGE_SIZE, totalFiltered.value)
})

watch([search, statusFilter, showArchived], () => {
  page.value = 1
})

watch(totalPages, (max) => {
  if (page.value > max) page.value = max
})

function goToPage (next) {
  page.value = Math.min(Math.max(1, next), totalPages.value)
}

function formatDate (v) {
  if (v == null || v === '') return '—'
  const formatted = formatLocalDate(v, locale.value)
  if (formatted && formatted !== 'Invalid Date') return formatted
  const d = parseLocalDate(v)
  if (!d || Number.isNaN(d.getTime())) return '—'
  const out = d.toLocaleDateString(locale.value)
  return out === 'Invalid Date' ? '—' : out
}

function validadeLabel (item) {
  if (!item?.validadeAte || item.status !== 'PUBLICADO') return ''
  const d = formatDate(item.validadeAte)
  return d === '—' ? '' : d
}



async function load () {

  if (!workspaceId.value) return

  loading.value = true

  try {

    const { data } = await api.get(`/orcamentos/workspace/${workspaceId.value}`)

    items.value = Array.isArray(data) ? data : []

  } catch (e) {

    console.error(e)

    items.value = []

  } finally {

    loading.value = false

  }

}



function novoOrcamento () {

  router.push(`/workspace/${workspaceId.value}/orcamentos/novo`)

}



function editar (id) {

  router.push(`/workspace/${workspaceId.value}/orcamentos/${id}`)

}



async function copiar (url) {

  try {

    await navigator.clipboard.writeText(url)

    const item = items.value.find(i => i.publicUrl === url)

    if (item) {

      copiedId.value = item.id

      clearTimeout(copiedTimer)

      copiedTimer = setTimeout(() => { copiedId.value = null }, 2200)

    }

  } catch { /* ignore */ }

}

async function arquivarOrcamento (item) {
  if (!item?.id || !workspaceId.value || archivingId.value) return

  const result = await Swal.fire({
    title: t('orcamentos.archiveTitle'),
    html: `
      <p style="margin-bottom: 12px;">${t('orcamentos.archiveConfirm')}</p>
      <p style="color: #64748b; font-size: 14px;">${t('orcamentos.archiveHint')}</p>
    `,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#ef4444',
    cancelButtonColor: '#6b7280',
    confirmButtonText: t('orcamentos.confirmArchive'),
    cancelButtonText: t('common.cancel'),
    reverseButtons: true
  })

  if (!result.isConfirmed) return

  archivingId.value = item.id
  try {
    await api.put(`/orcamentos/${item.id}/arquivar`, null, {
      params: { workspaceId: workspaceId.value }
    })
    await load()
  } catch (e) {
    console.error(e)
    await Swal.fire({
      title: t('orcamentos.archiveErrorTitle'),
      text: t('orcamentos.archiveErrorText'),
      icon: 'error',
      confirmButtonText: 'OK',
      confirmButtonColor: '#ef4444'
    })
  } finally {
    archivingId.value = null
  }
}



onMounted(load)

watch(workspaceId, load)

</script>


